import React from 'react'
import { CollapseButtonStyles } from './Style'
import { LightButton } from 'styles/GlobalStyle'
import { KeyboardArrowUp, KeyboardArrowDown } from '@mui/icons-material'

const CollapseButton = (props) => {
    const { open, onClick } = props

    return (
        <CollapseButtonStyles>
            <LightButton
                size="small"
                icon={open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                label="רשימת המבדקים"
                action={onClick}

            />
        </CollapseButtonStyles>
    )
}

export default CollapseButton